<template>
  <div>
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Device</label>
          <v-select
            :options="deviceList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.device"
            @search="searchDevice"
            class="mb-4 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="vs-input--label">Start Time</label>
          <flat-pickr
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              maxDate: maxDate,
              time_24hr: true,
              defaultHour: 0
            }"
            style="width: 100%"
            v-model="filter.start_time"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="vs-input--label">End Time</label>
          <flat-pickr
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              maxDate: maxDate,
              time_24hr: true,
              defaultHour: 23,
              defaultMinute: 59
            }"
            style="width: 100%"
            v-model="filter.end_time"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Alarm Status</label>
          <v-select
            :options="refAlertList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.alarm_type"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-button
            id="searchBtn"
            style="width: 100%"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="pl-5 mt-1 vs-con-loading__container"
            @click="search"
            >Search</vs-button
          >
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button
            v-if="data.length > 0"
            id="exportBtn"
            icon-pack="feather"
            icon="icon-file-text"
            color="success"
            type="border"
            class="mb-4 md:mb-0 vs-con-loading__container"
            @click="exportAlert"
            >Export</vs-button
          >
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ page * per_page - (per_page - 1) }} -
              {{
                row_total - page * per_page > 0 ? page * per_page : row_total
              }}
              of {{ row_total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>No</th>
              <th>Time</th>
              <th>Imei</th>
              <th>Device Name</th>
              <th v-if="actor.privilege <= 4">GSM Number</th>
              <th>Speed km/h</th>
              <th>Longitude</th>
              <th>Latitude</th>
              <th>Address</th>
              <th>Alarm Status</th>
            </tr>
          </thead>
          <tbody v-if="loading">
            <tr>
              <td colspan="10" class="text-center">Loading....</td>
            </tr>
          </tbody>
          <tbody v-else-if="data.length > 0">
            <tr v-for="(item, index) in data" :key="index">
              <td>{{ (page - 1) * per_page + (index + 1) }}</td>
              <td>{{ item.time }}</td>
              <td>{{ item.imei }}</td>
              <td>{{ item.gps.device_name }}</td>
              <td v-if="actor.privilege <= 4">{{ item.gps.gsm_no }}</td>
              <td>{{ item.speed }}</td>
              <td>{{ item.lon }}</td>
              <td>{{ item.lat }}</td>
              <td>{{ item.address }}</td>
              <td>
                {{
                  item.ref_alert
                    ? item.ref_alert.description
                    : `Unknown Alert (${item.alert})`
                }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="10" class="text-center">No Data Available</td>
            </tr>
          </tbody>
        </table>

        <vs-pagination :total="n_page" v-model="page"></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import FileDownload from 'js-file-download'

export default {
  components: {
    flatPickr,
    vSelect
  },

  data() {
    return {
      data: [],
      token: '',
      action: '',
      loading: true,
      actor: '',
      tempId: 0,

      filter: {
        device: '',
        start_time: null,
        end_time: null,
        alarm_type: null
      },

      filtered: {
        device: '',
        start_time: null,
        end_time: null,
        alarm_type: null
      },

      deviceList: [],
      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error',
      maxDate: '',
      refAlertList: []
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },

    alertParams() {
      return this.$store.state.alarm.alarm
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    alertParams() {
      if (this.alertParams.device !== '') {
        this.filter.start_time = this.alertParams.start_time
        this.filter.end_time = this.alertParams.end_time
        this.filter.device = {
          value: this.alertParams.device,
          label: this.alertParams.device + ' (imei)'
        }

        this.search()
      }
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.searchDevice('')
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  mounted() {
    if (this.alertParams.device !== '') {
      this.filter.start_time = this.alertParams.start_time
      this.filter.end_time = this.alertParams.end_time
      this.filter.device = {
        value: this.alertParams.device,
        label: this.alertParams.device + ' (imei)'
      }
      this.search()
    } else {
      if (localStorage.getItem('alertParams') !== null) {
        const params = JSON.parse(localStorage.getItem('alertParams'))

        this.filter.start_time = params.start_time
        this.filter.end_time = params.end_time
        this.filter.device = {
          value: params.device,
          label: params.device + ' (imei)'
        }

        localStorage.removeItem('alertParams')
        this.search()
      } else {
        this.loading = false
        let today = new Date()
        let date = `${today.getFullYear()}-${(today.getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`

        this.filter.start_time = `${date} 00:00`
        this.filter.end_time = `${date} 23:59`
      }
    }
    this.getRefAlert()
  },

  destroyed() {
    this.$store.dispatch('alarm/clearAlarm')
  },

  methods: {
    updatePerPage(n) {
      this.per_page = n
    },

    searchDevice(keyword) {
      if (this.actor.privilege >= 4) {
        this.getDataDevice(keyword)
      } else {
        if (keyword.length >= 3) {
          this.getDataDevice(keyword)
        } else {
          this.deviceList = []
        }
      }
    },

    getDataDevice(keyword) {
      this.$http
        .get(
          `${this.$api.endpoint}/tracking/search?keyword=${keyword}&type=vehicle`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.deviceList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    initTable() {
      this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/alert/datatable`, {
          params: {
            page: this.page,
            per_page: this.per_page,
            device: this.filter.device ? this.filter.device.value : '',
            start: `${this.filter.start_time}:00`,
            end: `${this.filter.end_time}:00`,
            alarm_type: this.filter.alarm_type
              ? this.filter.alarm_type.value
              : ''
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.loading = false
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)

          this.row_total = res.data.message.total
          this.data = res.data.message.data

          this.getAddress()
        })
        .catch((error) => {
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    search() {
      this.loading = true
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#searchBtn',
        scale: 0.45
      })

      this.$store.dispatch(
        'notification/clearUnreadNotification',
        this.filter.device.value
      )

      this.filtered.device = this.filter.device
      this.filtered.start_time = this.filter.start_time
      this.filtered.end_time = this.filter.end_time

      this.page = 1
      this.initTable()
    },

    exportAlert() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtn',
        scale: 0.45
      })

      this.$http
        .get(`${this.$api.endpoint}/alert/export`, {
          responseType: 'blob',
          params: {
            device: this.filtered.device ? this.filtered.device.value : '',
            start: `${this.filtered.start_time}:00`,
            end: `${this.filtered.end_time}:00`,
            alarm_type: this.filter.alarm_type
              ? this.filter.alarm_type.value
              : ''
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.$vs.loading.close(`#exportBtn > .con-vs-loading`)

          let filename = `Report Alert_${
            this.filtered.device.value
          }_${this.filtered.start_time
            .toString()
            .substr(0, 10)}_${this.filtered.end_time
            .toString()
            .substr(0, 10)}.xlsx`
          FileDownload(res.data, filename)
        })
        .catch((error) => {
          this.$vs.loading.close(`#exportBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    getAddress() {
      this.data.map((item, index) => {
        if (!item.address) {
          this.$http
            .get(`${this.$api.base_url}/api/address`, {
              params: {
                latitude: item.lat,
                longitude: item.lon
              }
            })
            .then((res) => {
              this.data[index].address = res.data.message
            })
        }
      })
    },

    getRefAlert() {
      this.$http
        .get(`${this.$api.endpoint}/ref_alert/list_alarm`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.refAlertList = res.data.message.data
          this.refAlertList.splice(0, 1)
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    }
  }
}
</script>
